import { Component, ViewChild,  TemplateRef } from '@angular/core';
import { UserService } from '../../../services/user.service';
import { Empresa } from '../../../models/empresa.model';
import { Validators, FormBuilder, FormControl } from '@angular/forms';
import { RutValidator } from 'ng9-rut';
import { FormService } from 'src/app/services/form.service';
import { MatDialog } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { startWith, map } from 'rxjs/operators';

declare var jQuery: any;
declare var $: any;
@Component({
    selector: "page-empresa",
    templateUrl: "./empresa.component.html",
    styleUrls: ["./empresa.component.css"],
    providers: [UserService, FormService]
})

export class EmpresaComponent {

    @ViewChild('openModal', { static: true }) openModal:TemplateRef<any>;
    public isNatural;
    public rut_emp
    public mail_emp
    public invalidRut: Boolean;
    public empresa: Empresa;
    public rows = [];
    public actualRow;

    public filteredOptions;
    public nombreComuna = new FormControl('', [ Validators.required]);
    options = []
    public selectedEmp: number = null;

    public matcher = new FormService();

    constructor(private fb: FormBuilder, private _userService: UserService, rutValidator: RutValidator,
                private dialog: MatDialog,private spinner: NgxSpinnerService){
        this.rut_emp = this.fb.group({
        rut: ['', [Validators.required, rutValidator]]
        })
        this.mail_emp = this.fb.group({
            mail: ['', [Validators.pattern(this.regexp), Validators.required, Validators.maxLength(50)]]
        })

        if(!JSON.parse(localStorage.getItem("empresas"))){
            localStorage.setItem("empresas", JSON.stringify(this.rows));
        }else{
            this.rows = JSON.parse(localStorage.getItem("empresas"));
        }
            this.invalidRut = true;
            this.empresa = {rut: '',nombre:'', direccion: '', direccion_num:'', direccion_complemento:'', direccion_completa:'',comuna:'',fono:'', fax:'', mail:'', recordId:''};
    }

    regexp = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
    
    ngOnInit() {
        this.getComunas()
        this.filteredOptions = this.nombreComuna.valueChanges
          .pipe(
            startWith(''),
            map(value => this._filter(value))
          );
      }

      private _filter(value: string): string[] {
        const filterValue = value.toLowerCase();
    
        return this.options.filter(option => option.toLowerCase().includes(filterValue));
      }

    get_empresa(rut){
        window.scroll(0,0);

        var rut_orig = rut;
        var dv;

       if (rut.includes("-")) {
            var fullRut = rut.split("-");
            rut = fullRut[0];
            dv = fullRut[1];
        } else {
            dv = rut
            rut = rut.toString();
            rut = rut.substring(0, rut.length - 1);
            dv = dv.slice(-1);
        }


        console.log("este es el rut limpio", rut)

        if(rut >= 50000000){
          this.isNatural = false;  
        }
        else{
            this.isNatural = true;
        }

        this.spinner.show();
        this.cleanData();
        this._userService.getEmpresa(rut_orig).subscribe(
            
            response => {
                console.log("get_empresa response", response);
                if(response.message){
                    this.empresa.rut = rut ? rut : '';
                    this.spinner.hide();
                    this.dialog.open(this.openModal);
                    
                } else {
                    this.empresa.rut = response.rut ? response.rut : '';
                    this.empresa.nombre = response.nombre ? response.nombre : '';
                    this.empresa.direccion = response.direccion ? response.direccion : '';
                    this.empresa.direccion_num = response.direccion_num ? response.direccion_num : '';
                    this.empresa.direccion_complemento = response.direccion_complemento ? response.direccion_complemento : '';
                    this.empresa.direccion_completa = response.direccion_completa ? response.direccion_completa : '';
                    this.empresa.comuna = response.comuna ? response.comuna : '';
                    this.empresa.fono = response.fono ? response.fono : '';
                    this.empresa.fax = response.fono ? response.fax : '';
                    this.empresa.mail = response.mail ? response.mail : '';
                    this.empresa.recordId = response.recordId ? response.recordId : '';
                    this.spinner.hide();
                    this.dialog.open(this.openModal);
                }

            },
            error => {
                console.log(error)
                this.spinner.hide();
            }
        )
    }





    cleanData(){
        this.empresa = {rut: '',nombre:'', direccion: '', direccion_num:'', direccion_complemento:'', direccion_completa:'',comuna:'',fono:'', fax:'', mail:'', recordId:''};
        this.rut_emp.reset()
    }

    update_empresa(rut, id) {
        this.get_empresa(rut);
        this.selectedEmp = id;
    }

    saveEmpresa() {
        window.scroll(0,0);
        //por si escriben un rut que ya esté ingresado
        for (let x = 0; x < this.rows.length; x++) {           
            if (this.empresa.rut == this.rows[x].rut) {                
                this.delete_empresa(x);
            }
        }

        //elimina fila cuando la editan
        /*if (this.selectedEmp != null) {
            this.delete_empresa(this.selectedEmp);
            this.selectedEmp = null;
        }*/
        this.spinner.show();
        this._userService.saveEmpresa(this.empresa).subscribe(
            response => {
                this.spinner.hide();

                console.log(response)
                if(response.update || response.save){
                    $("#emp_modal").modal("hide");
                    this.actualRow = localStorage.getItem("empresas");
                    this.rows = JSON.parse(this.actualRow);
                    this.rows = this.rows.concat({
                        rut: this.empresa.rut,
                        nombre: this.empresa.nombre,
                        direccion:this.empresa.direccion, 
                        direccion_num:this.empresa.direccion_num, 
                        direccion_complemento:this.empresa.direccion_complemento, 
                        direccion_completa:this.empresa.direccion_completa, 
                        comuna:this.empresa.comuna, 
                        fono:this.empresa.fono,
                        fax:this.empresa.fax,
                        mail:this.empresa.mail
                        
                    })
                    localStorage.setItem("empresas", JSON.stringify(this.rows));
                    this.empresa = {rut: '',nombre:'', direccion: '', direccion_num:'', direccion_complemento:'', direccion_completa:'',comuna:'',fono:'', fax:'', mail:'', recordId:''};
                    this.rut_emp.reset();
                    this.dialog.closeAll();
                    
                }
            },
            error => {
                this.spinner.hide();

                console.log(error)
            }
        )
    }
    delete_empresa(id) {
        for (let x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("empresas", JSON.stringify(this.rows));
                this.rows = JSON.parse(localStorage.getItem('empresas'));
            }
        }
    }

    getComunas() {

        this._userService.getComunas().subscribe(res => {
            //console.log('res', res);
            for (let i = 0; i < res.length; i++) {
                this.options.push(res[i].fieldData.COM_Nombre)
            }

            this.filteredOptions = this.nombreComuna.valueChanges
                .pipe(
                    startWith(''),
                    map(value => this._filter(value))
                );
        }, error => {
            console.log(error)
        })
    }
}